import { render, staticRenderFns } from "./AlertLookIntoModal.vue?vue&type=template&id=1ae1afc4&scoped=true&"
import script from "./AlertLookIntoModal.vue?vue&type=script&lang=ts&"
export * from "./AlertLookIntoModal.vue?vue&type=script&lang=ts&"
import style0 from "./AlertLookIntoModal.vue?vue&type=style&index=0&id=1ae1afc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae1afc4",
  null
  
)

export default component.exports